import React, { PureComponent } from 'react'
import 'react-table/react-table.css'
import { getUsers, deleteUser } from '../api'
import { getUser, insertUser } from '../api'
import FilterListIcon from "@material-ui/icons/FilterList";
import { withTranslation } from 'react-i18next';
import SupervisorAccountIcon from '@material-ui/icons/SupervisorAccount';
import { Box } from '@material-ui/core'
import Link from '@material-ui/core/Link';
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import CopyIcon from "@material-ui/icons/FileCopy";
import FilterableGrid from '../../../../Component/FilterableGrid';
import DeleteIcon from "@material-ui/icons/Delete";
import DialogWindow from '../../../../Component/DialogWindow'
import ScreenShareIcon from '@material-ui/icons/ScreenShare';
import { Link as RouterLink } from 'react-router-dom';
import {withLogin} from '../../../../Contexts/withLogin'
import {userTitle} from '../../../../domain/extensions/userExtensions'
import Chip from "@material-ui/core/Chip";

const ddlColumns = [
    {
        'userName': {
            title: 'شناسه',
            remote: true
        }
    },
    {
        'firstName': {
            title: 'نام',
            remote: true
        }
    }, {
        'lastName': {
            title: 'نام خانوادگی',
            remote: true
        }
    }
];


class List extends PureComponent {

    constructor(props) {
        super(props)
        this.state = {
            users: [],
            selection: [],
            selectAll: false,
            // userId: props.match.params.userId,
            openDeleteDialog:false

        }
    }

    onLogin(userId){
        alert('login ' +   userId);
    }

    columns = {
        'login':{
            title:'',
            format: (u) => <Link component="button" onClick={()=>this.props.switchUser(u.id)}><ScreenShareIcon/></Link>,
        },
        'firstName+lastName': {
            editLink : true,
            format:(b)=> userTitle(b),
            title: 'نام',
            remote: true
        },
        'userRoles': {
            title: 'نقش‌ها',
            format:(row)=>row.roles.map(r=><Chip style={{color:r.name==='SuperAdmin'?'red':'', marginBottom:2, marginRight:5}} label={r.displayName}></Chip>),
            remote: true
        },
        'province.name': {
            title: 'استان',
            remote: true
        },
        'phone': {
            title: 'تلفن',
            remote: true
        }

    };

    async componentDidMount() {

        await this.loadUsers()
    }

    refresh = async () => {
        await this.loadUsers();
    }

    loadUsers = async () => {
        var res = await getUsers({allAdmins:true}, this.props.onlyEmployees)
        if (res) {
            this.setState({ users: res, selection :[], selectAll:false, openDeleteDialog:false })
        }
    }

    onFilter = async (params) => {
        var res = await getUsers({...params, allAdmins:true}, this.props.onlyEmployees)
      
        if (res) {
            this.setState({ users: res, openDeleteDialog:false })
        }
    }

    deleteUsers = async () => {
        const res = await deleteUser(this.state.selection[0])
        if (res !== null){
            await this.loadUsers()
        }

    }


    showDeleteDialog = (open, selected) => () => {
        this.setState({ selection : selected, openDeleteDialog: open });
    };

    duplicate = (id) => async () => {
        var user = await getUser(id);
        if(user) {
            if( await insertUser({...user, id:undefined}))
                        await this.loadUsers()
        }
    };

    onEditClick =(id)=>{
        // const { match } = this.props;
        this.props.history.push(`/superadmin/user/${id}`)
    }
    onDeleteClick = (selected) => {
        this.setState({ selection : selected, openDeleteDialog: true });

    }
    selectionToolbar = ()=> {
        const {t}= this.props;
        return <>
        <Tooltip title={t('common:delete')}>
        <IconButton aria-label={t('common:delete')}>
            <DeleteIcon /*onClick={this.showDeleteDialog(true, selected)} */ />
        </IconButton>
        </Tooltip>
        <Tooltip title={t('common:duplicate')}>
            <IconButton aria-label={t('common:duplicate')}>
            <CopyIcon /*onClick={this.duplicate(selected[0])}*/ />
            </IconButton>
        </Tooltip>
        </>
    }

    toolbar = ()=> {
        const {t}= this.props;
        return <>
        <Tooltip title={t('common:new')}>
        <Button component={RouterLink} to={`/superadmin/user/create`} color="primary" >{t('new')}</Button>
        </Tooltip>
        <Tooltip title={t('common:filter')}>
            <IconButton aria-label={t('common:filter')}>
                <FilterListIcon />
            </IconButton>
        </Tooltip>
        </>
    }


DeleteDialog = () => {
    const {t}= this.props;
    return <Dialog
        open={true}
        onClose={this.handleCloseDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
    <DialogTitle id="alert-dialog-title" style={{direction:'rtl'}}>{t('delete')}</DialogTitle>
    <DialogContent>
        <DialogContentText id="alert-dialog-description">
            {t('delete?')}
        </DialogContentText>
    </DialogContent>
    <DialogActions>
        <Button onClick={this.showDeleteDialog(false)} color="primary">
            {t('common:cancel')}
        </Button>
        <Button onClick={this.deleteUsers} color="primary" autoFocus>
            {t('common:ok')}
        </Button>
    </DialogActions>
    </Dialog>
    }

    render() {
        const { users, openDeleteDialog } = this.state
        return (
        <>
            {openDeleteDialog&& this.DeleteDialog()}
            <FilterableGrid 
                data={users} 
                selectable = {this.props.selectable || true}
                pagination={false}
                title={<><Box whiteSpace="nowrap" display="flex"  ><SupervisorAccountIcon /><Box style={{paddingRight:10}}> لیست پنل مدیران شعب</Box></Box></>}
                selectionToolbar = {this.selectionToolbar}   
                toolbar = {this.toolbar}                    
                header = {this.props.columns ||this.columns}  
                onDelete = {this.onDeleteClick}
                onEdit = {this.onEditClick}
                onFilter = {this.onFilter}
                onSelect={this.props.onSelect}
            ></FilterableGrid>
        </>
        )
    }
}

export class ListDialog extends PureComponent {

    render() {
        return <DialogWindow  open={this.props.open} onClose={this.props.onClose} > 
            <List  
                columns={ddlColumns}  
                selectable={1}  
                {...this.props} /> 
        </DialogWindow>
    }
}


export default withTranslation('appuser')(withLogin(List));
